import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ padding: 60, textAlign: "center" }}>
      <h2>404 — Page not found</h2>
      <Link to="/" style={{ color: "var(--color-primary)", fontWeight: 600 }}>
        Go back home
      </Link>
    </div>
  );
}
